import identificationValidation from "../commonValidationSchema/identificationValidation";
import residentialDetailsValidation from "../commonValidationSchema/residentialDetailsValidation";
import uploadChangeDocumentsValidation from "../commonValidationSchema/uploadChangeDocumentsValidation";
import uploadDocumentsValidation from "../commonValidationSchema/uploadDocumentsValidation";

/**
 * This returns an object composed of conditional initial values using `yup` schema
 * for identification, residential details and upload documents forms
 * of `Director` and `Authorized Person` officials.
 *
 * @param {string} idType The idType of the current official e.g `"Kenyan Citizen"`.
 * @param {string} isNonResident Conditional string value `'No' || 'Yes` of the current official.
 * @param {array} documentData The array of objects related to file uploads.
 * @return {object} This returns object containing initial values.
 * @example
 *  {}
 */

let ManageModuleChangeDocumentsData = [
  {
    documentsAreSigned: "true",
    fileMustUpload: true, // For signed documents, file upload is always required
  },
  {
    documentsAreSigned: "false",
    selectResolutionType: "ownResolutionType",
    fileMustUpload: true, // For documents not yet signed with own resolution type selected, file upload is required
  },
  {
    documentsAreSigned: "false",
    selectResolutionType: "platformResolutionType",
    fileMustUpload: false, // For documents not yet signed with platform resolution type selected, file upload is not required
  },
];

const getInitialValues = ({
  idType,
  isNonResident = null,
  documentData,
  actionType = null,
}) => {
  return {
    ...identificationValidation({ idType }).schemaInitialValues,
    ...residentialDetailsValidation({ idType, isNonResident })
      .schemaInitialValues,
    ...uploadDocumentsValidation(documentData).schemaInitialValues,
    ...uploadChangeDocumentsValidation(
      actionType === "Appointment"
        ? ManageModuleChangeDocumentsData
        : documentData
    ).schemaInitialValues,
  };
};

export default getInitialValues;
